import React from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./index.scss";
import appleTvIcon from "../../assets/images/appletv.png";
import iosIcon from "../../assets/images/ios.png";
import fireTvIcon from "../../assets/images/firetv.png";
const FailPage = (props) => {
  const navigate = useNavigate();

  const openStore = (e) => {
    e.preventDefault();
    const {platform} = e.target.dataset;
    let url = "";

    switch (platform) {
      case "fire-tv":
        url = "https://www.amazon.com/Credo-LLC/dp/B0F9LR1DGY/ref=sr_1_1?dib=eyJ2IjoiMSJ9.08boKYN2OhHwd_ohs2n8JA.nbFIIml1yGgOXqmVjcPJmiK0rrla6P3fIpGXOn5kYWE&dib_tag=se&keywords=credo&qid=1748328428&s=mobile-apps&sr=1-1";
        break;
      case "apple-tv":
        url = "https://apps.apple.com/us/app/credo-app/id6744193482";
        break;
      case "ios":
        url = "https://apps.apple.com/us/app/credo-app/id6744193482";
        break;
      default:
        return;
    }

    window.open(url, "_blank");
  }

  return (
    <div className="error-page">
      <div className="message-wrapper">
        Your transaction got failed !
      </div>
      <input className="signup-btn" type="button"  onClick={(e)=>{navigate('/home')}} value="Back to home" />
       <div className="icon-wrapper">
        <img src={fireTvIcon} alt="Fire TV" className="platform-icon" data-platform="fire-tv" onClick={openStore} />
        <img src={appleTvIcon} alt="Apple TV" className="platform-icon" data-platform="apple-tv" onClick={openStore} />
        <img src={iosIcon} alt="ios" className="platform-icon" data-platform="ios" onClick={openStore} />
      </div>
    </div>
  );
};

export default FailPage;
